<template>
  <div class="home" v-show="display">
    <v-card tile max-width="1200px">
      <div style="position:relative;width:100%">
        <v-carousel continuous :cycle="cycle" :hide-delimiters="!cycle" interval="4000" :show-arrows="false" hide-delimiter-background show-arrows-on-hover :height="topHeight">
          <v-carousel-item v-for="(item, i) in MeetingPhoto" :key="i" eager>
            <!-- <v-img v-if="item.type === 1" aspect-ratio="16/9" class="white--text align-end" max-width="100%" width="1200px" height="250" :src="item.url">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img> -->
            <van-image v-if="item.type === 1" fit="cover" width="100%" :height="topHeight" lazy-load :src="item.url">
              <!-- <template v-slot:loading>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template> -->
            </van-image>
            <div v-if="item.type === 2" style="width:1200px;max-width:100%">
              <video style="object-fit:cover;" id="myVideo" width="100%" :height="topHeight" @playing="cycle = false" @pause="cycle = true" controls controlsList="nodownload" :src="item.url">
              </video>
            </div>
          </v-carousel-item>
        </v-carousel>
         <v-btn-toggle mandatory v-model="languageExclusive" rounded v-if="data.IsNeedEnglish === 1 && cycle" style="position:absolute;right:0px;top:0px;z-index:2;" class="ml-auto mr-2 mt-2 align-self-end">
          <v-btn active-class="primary white--text" class="black--text white" width="50%" @click="changeLangEvent(0)">中文</v-btn>
          <v-btn active-class="primary white--text" class="black--text white" width="50%" style="text-transform:none;" @click="changeLangEvent(1)">English</v-btn>
        </v-btn-toggle>
        <!-- <v-btn v-if="data.IsNeedEnglish === 1" style="position:absolute;right:0px;top:0px;z-index:2;" class="ml-auto mr-2 mt-2 align-self-end" color="primary" @click="languageDialog = true">{{$t('lang.language')}}</v-btn> -->
        <v-btn v-if="cycle" style="text-transform:none;position:absolute;right:0px;bottom:0px;z-index:2;" class="d d-sm d-md-none ml-auto mr-2 mb-2 align-self-end" color="primary" @click="register()">{{$t('lang.register')}}</v-btn>
      </div>
      <v-card-text class="d-sm-inline-flex" style="width:1200px;max-width:100%">
        <v-card-text class="ma-0 pa-0 text--primary text-text-1 grey--text text--darken-2">{{$t('lang.conferenceTime') + '：' + conferenceTime}}</v-card-text>
        <v-card-text v-if="conferencePlace" class="ma-0 pa-0 text--primary text-sm-right text-text-1 grey--text text--darken-2">{{$t('lang.conferencePlace') + '：' + conferencePlace}}</v-card-text>
      </v-card-text>
    </v-card>
    <v-card outlined tile max-width="1200px" color="white">
      <div class="fixed-tabs-bar d-flex align-center">
        <v-tabs v-if="isRouterShow" v-model="tab" center-active show-arrows grow>
          <v-tab @change="TabsChange(i)" v-for="(item, i) in items" :key="i" style="text-transform:none;" class="font-weight-bold text-subtitle-1 black--text" active-class="blue--text text--darken-2" :href="`#tab-${item.tag}`">
            {{$t('lang.' + item.name)}}
          </v-tab>
        </v-tabs>
        <v-btn style="text-transform:none;" class="d-none d-sm-none d-md-flex ml-12 mr-2" color="primary" @click="register()">{{$t('lang.register')}}</v-btn>
      </div>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, i) in items" :key="i" :id="`tab-${item.tag}`">
          <component :is="item.cpt" :data="data" :back="back" :signUp="signUp"></component>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-dialog v-model="dialog" max-width="290" transition="dialog-top-transition">
      <v-card>
        <v-card-title class="headline">提示</v-card-title>
        <v-card-text v-text="msg" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="dialog = false">
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="languageDialog" max-width="290" transition="dialog-bottom-transition">
      <v-card>
        <v-card-title class="headline">{{$t('lang.tip')}}</v-card-title>
        <v-card-text v-text="$t('lang.languageTip')" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal"  @click="languageDialog = false">
            {{$t('lang.no')}}
          </v-btn>
          <v-btn color="primary"  @click="changeLangEvent()">
            {{$t('lang.yes')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.fixed-tabs-bar{
  background: white;
  position: sticky;
  top: 0rem;
  z-index: 2;
}
.v-slide-group__next.v-slide-group__next--disabled, .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none;
  /* visibility: hidden; */

}
.v-carousel__item{
  height: auto !important;
}
video::-internal-media-controls-download-button {
  display:none;
}
video::-webkit-media-controls-enclosure {
  overflow:hidden;
}
video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
.v-carousel__controls {
  left: 15%!important;
  width: 70%!important;
}
</style>
<script>
// @ is an alias to /src
import Introduce from '@/components/Introduce'
import News from '@/components/News'
import Expert from '@/components/Expert'
import Articles from '@/components/Articles'
import Register from '@/components/Register'
import Survey from '@/components/Survey'
import wx from 'weixin-js-sdk'
import utils from '../utils/utils.js'
import urls from '../utils/urls'

export default {
  name: 'Home',
  components: {
    Introduce,
    News,
    Expert,
    Articles,
    Register,
    Survey
  },
  data: () => ({
    back: 0,
    display: false,
    dialog: false,
    languageExclusive: 0, // 0是中文，1是英文
    languageDialog: false,
    msg: '',
    MeetingPhoto: null,
    cycle: true, // 轮播图是否循环播放
    submitUrl: urls.lijiaobaoming,
    tab: 'tab-introduce',
    items: [],
    isRouterShow: true,
    signUp: true,
    data: {}
  }),
  computed: {
    conferencePlace () {
      return this.$store.getters.getLanguage === 0 ? this.data.SignupUrl : this.data.SignupUrlEnglish
    },
    conferenceTime () {
      if (this.$store.getters.getLanguage === 0) {
        // return this.data.StartTime + '——' + this.data.EndTime
        return this.data.EndTime
      }
      // return utils.methods.getEnglishDate(this.data.StartTime) + '——' + utils.methods.getEnglishDate(this.data.EndTime)
      return utils.methods.getEnglishDate(this.data.EndTime)
    },
    topHeight () {
      return utils.methods.isMobile() ? '250px' : '300px'
    }
  },
  mounted () {
    if (navigator.language.indexOf('en') >= 0 || this.getRequest('lang') === 'en' || this.$store.getters.getLanguage === 1) {
      this.languageExclusive = 1
      this.$i18n.locale = 'en-US'
      this.$store.commit('setLanguage', 1)
    } else {
      this.languageExclusive = 0
      this.$i18n.locale = 'zh-CN'
      this.$store.commit('setLanguage', 0)
    }
    if (this.$store.getters.getLogin4SignAgain || this.$store.getters.getBackFromCheckin) {
      this.$nextTick(() => {
        this.tab = 'tab-register'
      })
    }
    this.$http.get('/SignUp/GetOmpSignup', {
      requestBase: 'VUE_APP_API',
      params: {
        id: this.getRequest('id') // QUZhZk1O可用
      }
    }).then(res => {
      if (res.data.ret === 0) {
        console.log(res.data.data)
        this.data = res.data.data
        this.$store.commit('setData', this.data)
        document.title = this.$store.getters.getLanguage === 0 ? this.data.Subject : this.data.EnglishSubject
        let photos = null
        if (!utils.methods.isMobile() && res.data.data.MeetingPhotoWeb !== null) {
          photos = res.data.data.MeetingPhotoWeb.substr(0, res.data.data.MeetingPhotoWeb.length - 1)
        } else {
          photos = res.data.data.MeetingPhoto && res.data.data.MeetingPhoto.substr(0, res.data.data.MeetingPhoto.length - 1)// 去掉末尾的逗号
        }
        if (photos !== null) {
          photos = photos.split(',')
          this.MeetingPhoto = []
          for (let index = 0; index < photos.length; index++) {
            const item = {}
            item.type = photos[index].indexOf('mp4') === -1 ? 1 : 2 // 图片jpg、png为1,视频mp4为2
            item.url = photos[index]
            this.MeetingPhoto.push(item)
          }
        }
        this.initQQShare()
        this.initWx()
        this.items.push({ name: 'conferenceIntroduction', cpt: Introduce, tag: 'introduce' })
        if (this.data.SignUpNews.length !== 0) {
          this.items.push({ name: 'conferenceNews', cpt: News, tag: 'news' })
        }
        if (this.data.SignUpExperts.length !== 0) {
          this.items.push({ name: 'introductionOfExperts', cpt: Expert, tag: 'expert' })
        }
        if (res.data.data.IsSolicit === 1) {
          this.items.push({ name: 'conferenceCallForPapers', cpt: Articles, tag: 'articles' })
        }
        this.items.push({ name: 'registration', cpt: Register, tag: 'register' })
        if (res.data.data.IsSatisfaction === 1) {
          this.items.push({ name: 'questionnaire', cpt: Survey, tag: 'survey' })
        }
        this.display = true
        if (this.getRequest('userid') && this.getRequest('kid')) {
          this.$nextTick(() => {
            this.tab = 'tab-articles'
          })
        }
      } else {
        this.msg = res.data.msg
        this.dialog = true
      }
    }).catch(e => {
      console.log(e)
    })
  },
  methods: {
    TabsChange (index) {
      this.signUp = false
      this.back++
    },
    changeLangEvent (lang) {
      if (this.$store.getters.getLanguage !== lang) {
        this.languageExclusive = lang
        this.$i18n.locale = lang === 0 ? 'zh-CN' : 'en-US'
        this.$store.commit('setLanguage', lang)
        document.title = lang === 0 ? this.data.Subject : this.data.EnglishSubject
        this.languageDialog = false
        this.reload()
      }
    },
    async reload () {
      this.isRouterShow = false
      await this.$nextTick()
      this.isRouterShow = true
    },
    playOrPause () {
      var myVideo = document.getElementById('myVideo')
      if (myVideo.paused) {
        myVideo.play()
      } else {
        myVideo.pause()
      }
    },
    register () {
      this.signUp = false
      this.$nextTick(() => {
        this.signUp = true
        this.tab = 'tab-register'
      })
    },
    getRequest (key) {
      // 获取参数
      var url = window.location.search
      // 正则筛选地址栏
      var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
      // 匹配目标参数
      var result = url.substr(1).match(reg)
      // 返回参数值
      return result ? decodeURIComponent(result[2]) : null
    },
    initQQShare () {
      window.setShareInfo && window.setShareInfo({
        title: this.data.Subject, // 必填
        summary: utils.methods.getChineseAndPoint(JSON.stringify(this.data.Introduce)), // 必填
        pic: this.data.MeetingPhoto, // 必填
        url: location.href.split('#')[0]
      })
    },
    initWx () {
      this.$http.get('/SignUp/GetWeixinJsInfo', {
        requestBase: 'VUE_APP_API',
        params: {
          // url: encodeURIComponent(location.href.split('#')[0])
          url: location.href.split('#')[0]
        }
      }).then(res => {
        console.log(res)
        wx.config({
          debug: process.env.VUE_APP_TEST === 'true', // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.AppId, // 必填，公众号的唯一标识
          timestamp: res.data.Timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.Noncestr, // 必填，生成签名的随机串
          signature: res.data.Signature, // 必填，签名，见附录1
          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(res => {
          var msg = {
            title: this.data.Subject, // 分享标题
            desc: utils.methods.getChineseAndPoint(JSON.stringify(this.data.Introduce)), // 分享描述
            link: location.href.split('#')[0], // 分享链接 该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.data.MeetingPhoto // 分享图标
          }
          wx.onMenuShareAppMessage(msg)
          wx.onMenuShareQQ(msg)
          wx.onMenuShareTimeline({
            title: this.data.Subject, // 分享标题
            link: location.href.split('#')[0], // 分享链接 该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.data.MeetingPhoto // 分享图标
          })
        })
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
